<template>
    <header class="header-global">
        <base-nav class="navbar-dark bg-gradient-default" effect="light" expand>
            <router-link slot="brand" class="navbar mr-lg-5" to="/">
                <img class="logo" src="static/img/brand/pj_white.png">
                <span class="title"> | Football Transfer Quiz</span>
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="../index.html">
                        <img class="logo" src="static/img/brand/logo_gradient.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <li class="nav-item">
                    <router-link to="/" class="nav-link" role="button">
                        <i class="fa fa-home d-lg-none"></i>
                        <span class="nav-link-inner--text">Home</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ path: '/', hash: 'tutorial' }" class="nav-link" role="button">
                        <i class="fa fa-trophy d-lg-none"></i>
                        <span class="nav-link-inner--text">Tutorial</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ path: '/', hash: 'hiscores' }" class="nav-link" role="button">
                        <i class="fa fa-trophy d-lg-none"></i>
                        <span class="nav-link-inner--text">Hiscores</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/start-game?difficulty=EASY" class="nav-link" role="button">
                        <i class="ni ni-support-16 d-lg-none"></i>
                        <span class="nav-link-inner--text">Easy</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/start-game?difficulty=NORMAL" class="nav-link" role="button">
                        <i class="ni ni-send d-lg-none"></i>
                        <span class="nav-link-inner--text">Normal</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/start-game?difficulty=HARD" class="nav-link" role="button">
                        <i class="ni ni-spaceship d-lg-none"></i>
                        <span class="nav-link-inner--text">Hard</span>
                    </router-link>
                </li>

            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://www.instagram.com/playerjourneys" target="_blank"
                        data-toggle="tooltip" title="Follow us on Instagram">
                        <i class="fa fa-instagram"></i>
                        <span class="nav-link-inner--text d-lg-none">Instagram</span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import CloseButton from "@/components/CloseButton";

export default {
    components: {
        BaseNav,
        CloseButton
    }
};
</script>
<style>
.header-global {
    width: 100%;
}

.title {
    color: white;
}

.logo {
    width: 24px;
}
</style>
